import {inject, Injectable} from "@angular/core";
import {WrapperDto} from "../../dto/wrapper.dto";
import {OrgDto} from "../../dto/org.dto";
import {UrlBuilder} from "../../item/url.item";
import {HttpClient} from "@angular/common/http";
import {Observable, tap} from "rxjs";
import {SearchRequest} from "../../dto/search/search-table.dto.req";
import {VoidDto} from "../../dto/void.dto";
import {VehicleHistoryDto} from "../../dto/vehicle/vehicle-history.dto";
import {map} from "rxjs/operators";
import {SearchVehicleHistoryRes} from "../../dto/vehicle/search-vehicle-history.res";
import {isUuid} from "../../../libs/utils/epic.utils";

@Injectable({providedIn: 'root'})
export class VehicleHistoryRepo {

  private readonly vhRead = '/v1/org/{orgId}/vehicle/{vehicleId}/history/{id}';
  private readonly vhWrite = '/v1/org/{orgId}/vehicle/{vehicleId}/history';
  private readonly vhDelete = '/v1/org/{orgId}/vehicle/{vehicleId}/history/{id}/delete';
  private readonly vhSearch = '/v1/org/{orgId}/vehicle/{vehicleId}/history/search';

  private readonly http: HttpClient = inject(HttpClient);

  public getById(org: OrgDto, id: string, vehicleId: string): Observable<WrapperDto<VehicleHistoryDto>> {
    const url = UrlBuilder.builder().addPath(this.vhRead).addParam('orgId', org.id)
      .addParam('vehicleId', vehicleId).addParam('id', id).build();
    return this.http.get<WrapperDto<VehicleHistoryDto>>(url.getUrl(), url.getOptions())
      .pipe(map((res) => new WrapperDto(res)));
  }

  public update(org: OrgDto, vehicleId: string, vh: VehicleHistoryDto): Observable<WrapperDto<VehicleHistoryDto>> {
    const url = UrlBuilder.builder().addPath(this.vhWrite).addParam('orgId', org.id)
      .addParam('vehicleId', vehicleId).build();
    return this.http.post<WrapperDto<VehicleHistoryDto>>(url.getUrl(), vh, url.getOptions())
      .pipe(map((res) => new WrapperDto(res)));
  }

  public delete(org: OrgDto, id: string, vehicleId: string): Observable<WrapperDto<VoidDto>> {
    const url = UrlBuilder.builder().addPath(this.vhDelete).addParam('orgId', org.id)
      .addParam('vehicleId', vehicleId).addParam('id', id).build();
    return this.http.post<WrapperDto<VoidDto>>(url.getUrl(), {}, url.getOptions())
      .pipe(map((res) => new WrapperDto(res)));
  }

  // ##########################################################################
  // #### Search
  // ##########################################################################

  public search(org: OrgDto, request: SearchRequest): Observable<WrapperDto<SearchVehicleHistoryRes>> {
    const vehicleId = request.filters.find((f) => f.pos === 1001)?.selected?.find((s) => isUuid(s));
    const url = UrlBuilder.builder().addPath(this.vhSearch).addParam('orgId', org.id).addParam('vehicleId', vehicleId).build();
    return this.http.post<WrapperDto<SearchVehicleHistoryRes>>(url.getUrl(), request, url.getOptions()).pipe(
      tap((res) => res.dataType = res.dataType === 'SearchResultDto' ? 'SearchVehicleHistoryRes' : res.dataType),
      map((res) => new WrapperDto(res))
    );
  }
}
